import { BaseModel } from '~/models/baseModel';

export class EntityConstantsModel extends BaseModel {
    public brokerServices:string[];
    public buyerServices:string[];
    public buyerWoolTypes:string[];
    public classerCertifications:string[];
}
